import React, { useEffect, useRef, useState } from "react";

/* ---------- Hook: detect when section is active ---------- */
function useInView({ threshold = 0.25, rootMargin = "0px 0px -15% 0px" } = {}) {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(([entry]) => setActive(entry.isIntersecting), {
      threshold,
      rootMargin,
    });

    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold, rootMargin]);

  return { ref, active };
}

function A4HCivicLeadership() {
  const { ref, active } = useInView();

  // ✅ Replace with your actual video (local import or URL)
  const VIDEO_SRC = "/videos/a4h-civic-leadership.mp4";

  const [isMuted, setIsMuted] = useState(true);
const [isPlaying, setIsPlaying] = useState(true);
const videoRef = useRef(null);

useEffect(() => {
  const v = videoRef.current;
  if (!v) return;

  // help autoplay
  v.muted = true;

  const p = v.play();
  if (p && typeof p.then === "function") {
    p.then(() => setIsPlaying(true)).catch(() => setIsPlaying(false));
  } else {
    setIsPlaying(!v.paused);
  }
}, []);

const togglePlayPause = async () => {
  const v = videoRef.current;
  if (!v) return;

  if (v.paused) {
    try {
      await v.play();
      setIsPlaying(true);
    } catch {
      setIsPlaying(false);
    }
  } else {
    v.pause();
    setIsPlaying(false);
  }
};

const toggleMute = () => setIsMuted((m) => !m);

  return (
    <>
      <style>{`
        html, body { overflow-x: hidden; }
        .block.color-scheme-4{
  padding-top: 0 !important;
  margin-top: 0 !important;
  min-height: auto !important;
}

.section-sub-title{
  margin-top: 0 !important;
  padding-top: 20px !important;
}
        /* ✅ Optional subtle reveal for the content block (keeps your in-view hook useful) */
        .a4h-content{
          opacity: 0;
          transform: translateY(16px);
          filter: blur(6px);
          transition: opacity 650ms ease, transform 650ms ease, filter 650ms ease;
          will-change: opacity, transform, filter;
        }
        .a4h-content.is-active{
          opacity: 1;
          transform: translateY(0);
          filter: blur(0);
        }

        /* ✅ FULL-WIDTH + FULL-HEIGHT VIDEO SECTION */
        .a4h-fullVideo{
  width: 90%;
  max-width: 1600px;
  margin: 40px auto;
  height: auto;
  background: #000;
  position: relative;
  overflow: visible;
}
        .a4h-fullVideo video{
  width: 100%;
  height: auto;
  object-fit: contain;
}

        

        .mt-4{
          margin-top: 1.5rem !important;
        }

        .a4h-videoControls{
          position: absolute;
          top: auto;
          right: auto;
          bottom: 16px;
          left: 16px;
          display: flex;
          gap: 10px;
          z-index: 3;
        }

        .a4h-ctrlBtn{
          border: 1px solid rgba(255,255,255,.22);
          background: rgba(0,0,0,.45);
          color: #fff;
          border-radius: 999px;
          padding: 10px 14px;
          font-size: 13px;
          letter-spacing: .02em;
          backdrop-filter: blur(10px);
          cursor: pointer;
          white-space: nowrap;
        }

        .a4h-ctrlBtn:hover{ background: rgba(0,0,0,.6); }
        .section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
/* Remove line under heading */
.hra-topTitle::after,
.hra-topTitle::before {
  display: none !important;
  content: none !important;
}
.desktop-title{
  display: inline;
}

.mobile-title{
  display: none;
}
.a4h-btn-icon{
  display:none;
}

.a4h-btn-text{
  display:inline;
}
/* ================= MOBILE VERSION ================= */
@media (max-width: 768px) {

  
  .desktop-title{
    display: none;
  }

  .mobile-title{
    display: block;
    font-size: 1.15rem !important;
    line-height: 1.25 !important;
    text-align: center;
    font-weight: 700;
    letter-spacing: 0.3px;
  }
  .container{
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .section-sub-title{
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  /* Heading */
  .hra-topTitle{
    font-size: 1.45rem !important;
    line-height: 1.25 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .head-title{
    margin-bottom: 5px !important;
  }

  /* Divider - reduce gap */
  .section-divider{
    margin: 8px auto 12px !important;
    gap: 8px !important;
  }

  .section-divider span{
    font-size: 16px !important;
  }

  .section-divider::before,
  .section-divider::after{
    height: 2px !important;
  }

  /* Intro text below divider */
  .hra-topIntro{
    font-size: 0.9rem !important;
    line-height: 1.5 !important;
    margin-top: 0 !important;
    margin-bottom: 10px !important;
    padding: 0 8px !important;
  }

  /* Main content text */
  .section-title-body p{
    font-size: 0.85rem !important;
    line-height: 1.6 !important;
    padding: 0 5px !important;
  }

  /* List text */
  .arrow-list li{
    font-size: 0.85rem !important;
    line-height: 1.6 !important;
    margin-bottom: 6px !important;
  }

  /* Video spacing */
  .a4h-fullVideo{
    margin: 10px auto !important;
  }

  .a4h-videoControls{
    bottom: 6px !important;
    left: 6px !important;
    gap: 4px !important;
  }

  .a4h-btn-text{
  display:none;
}

.a4h-btn-icon{
  display:inline;
  font-size:20px;
  line-height:1;
}

.a4h-videoControls{
  bottom:6px;
  left:6px;
  gap:4px;
}

.a4h-ctrlBtn{
  background:transparent !important;
  border:none !important;
  box-shadow:none !important;
  backdrop-filter:none !important;
  padding:0 !important;
  width:auto !important;
  height:auto !important;
  min-width:auto !important;
  border-radius:0 !important;
  color:#fff;
  cursor:pointer;
}

.a4h-ctrlBtn:hover,
.a4h-ctrlBtn:focus,
.a4h-ctrlBtn:active{
  background:transparent !important;
  box-shadow:none !important;
}
}

/* Extra Small Devices */
@media (max-width: 480px){

  .hra-topTitle{
    font-size: 1.5rem !important;
  }
  .mobile-title{
    font-size: 1rem !important;
    line-height: 1.2 !important;
  }
  .hra-topIntro{
    font-size: 0.9rem !important;
  }

  .section-title-body p{
    font-size: 0.9rem !important;
  }

  .arrow-list li{
    font-size: 0.9rem !important;
  }

  .a4h-btn-text{
  display:none;
}

.a4h-btn-icon{
  display:inline;
  font-size:20px;
  line-height:1;
}

.a4h-videoControls{
  bottom:6px;
  left:6px;
  gap:4px;
}

.a4h-ctrlBtn{
  background:transparent !important;
  border:none !important;
  box-shadow:none !important;
  backdrop-filter:none !important;
  padding:0 !important;
  width:auto !important;
  height:auto !important;
  min-width:auto !important;
  border-radius:0 !important;
  color:#fff;
  cursor:pointer;
}

.a4h-ctrlBtn:hover,
.a4h-ctrlBtn:focus,
.a4h-ctrlBtn:active{
  background:transparent !important;
  box-shadow:none !important;
}

  .section-divider span{
    font-size: 16px !important;
  }
}
        

      `}</style>

      <section>
        <div className="block color-scheme-4">
          {/* ✅ 1) FIRST: Heading + small intro content */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article ref={ref} className={`section-title-body white a4h-content ${active ? "is-active" : ""}`}>
                    <h1 className="head-title hra-topTitle">
  <span className="desktop-title">
    A4H PAC (Political Action Committee)
  </span>

  <span className="mobile-title">
    A4HPAC
    <br />
    (POLITICAL ACTION COMMITTEE)
  </span>

  <div className="section-divider">
    <span>✦ ✦ ✦</span>
  </div>
</h1>

                    <p className="hra-topIntro">
                      A4H expands civic knowledge and political representation through:
                    </p>
                  </article>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ 2) SECOND: Full-width + full-height video (NO IMAGES) */}
          <div className="a4h-fullVideo">
            <video
              ref={videoRef}
              src={VIDEO_SRC}
              playsInline
              autoPlay
              loop
              muted={isMuted}
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            <div className="a4h-videoControls">
  <button
    type="button"
    className="a4h-ctrlBtn"
    onClick={togglePlayPause}
  >
    <span className="a4h-btn-text">
      {isPlaying ? "Pause ⏸️" : "Play ▶️"}
    </span>
    <span className="a4h-btn-icon">
      {isPlaying ? "⏸️" : "▶️"}
    </span>
  </button>

  <button
    type="button"
    className="a4h-ctrlBtn"
    onClick={toggleMute}
  >
    <span className="a4h-btn-text">
      {isMuted ? "Unmute 🔊" : "Mute 🔇"}
    </span>
    <span className="a4h-btn-icon">
      {isMuted ? "🔇" : "🔊"}
    </span>
  </button>
</div>
          </div>

          {/* ✅ 3) THIRD: Remaining content AFTER video */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    <div className="mt-4">
                      <p className="white" style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
                        <strong>Americans4Hindus</strong> is a  nationally active, non-partisan Political Action Committee (PAC) 
                        committed to empowering American Hindus and like-minded communities to participate 
                        meaningfully in the U.S. political process and public life. As a bipartisan PAC, it champions 
                        the values of equality, tolerance, diversity, and religious freedom while advocating for 
                        issues that affect Hindu and Dharmic communities, including combating Hinduphobia, 
                        promoting civic engagement, and fostering cultural understanding and policy awareness. 
                        Through strategic endorsements, voter outreach, leadership development initiatives such 
                        as the Rajneeti Academy, and grassroots mobilization, Americans4Hindus works to 
                        strengthen representation at local, state, and national levels, encourage informed 
                        participation in democracy, and ensure that the voices of Hindu Americans are heard in 
                        governance and decision-making. Its efforts include establishing and supporting 
                        candidates who uphold these principles, advancing civic education, and building alliances 
                        that reflect inclusive American values and vibrant community engagement.
                      </p>
                      <ul className="white arrow-list">
                        <li>Civic leadership workshops</li>
                        <li>Policy briefings &amp; issue awareness</li>
                        <li>Candidate evaluations &amp; scorecards</li>
                        <li>Advocacy at local, state &amp; federal levels</li>
                        <li>Voter mobilization campaigns</li>
                        <li>Engagement with Congressional offices</li>
                      </ul>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default A4HCivicLeadership;
